import { useState, useEffect } from "react";

import {
  fetchRolesAPI,
  fetchManagersAPI,
  fetchSBUHeadsAPI,
  registerUserAPI
} from "../../../api/register_api";

export default function useRegister() {

  const [form, setForm] = useState({
    empID: "",
    name: "",
    designation: "",
    location: "",
    email: "",
    password: "",
    roleName: "",
    reportingManagerName: "",
    sbuHeadName: "",
  });

  const [roles, setRoles] = useState([]);
  const [managers, setManagers] = useState([]);
  const [sbuHeads, setSbuHeads] = useState([]);

  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  /* =============================
        LOAD DROPDOWNS
  ============================== */
  useEffect(() => {
    async function loadDropdowns() {
      try {
        const rolesData = await fetchRolesAPI();
        const managersData = await fetchManagersAPI();
        const sbuData = await fetchSBUHeadsAPI();

        setRoles(rolesData.roles || []);
        setManagers(managersData.managers || []);
        setSbuHeads(sbuData.sbuHeads || []);
      } catch (err) {
        console.error("Dropdown Load Failed", err);
      }
    }

    loadDropdowns();
  }, []);

  /* =============================
        ROLE LOGIC
  ============================== */
  const handleRoleLogic = (roleName, prev) => {
    const r = roleName.toLowerCase();

    if (r === "employee") {
      return { ...prev, roleName, reportingManagerName: "" };
    }

    if (r === "manager" || r === "sbuhead" || r === "sbu head") {
      return {
        ...prev,
        roleName,
        reportingManagerName: prev.sbuHeadName || "",
      };
    }

    return { ...prev, roleName };
  };

  /* =============================
        INPUT CHANGE
  ============================== */
  const handleInput = (e) => {
    const { name, value } = e.target;

    setForm((prev) => {
      let updated = { ...prev, [name]: value };

      if (name === "roleName") {
        updated = handleRoleLogic(value, prev);
      }

      if (name === "sbuHeadName") {
        const role = prev.roleName.toLowerCase();
        if (role === "manager" || role === "sbuhead" || role === "sbu head") {
          updated.reportingManagerName = value;
        }
      }

      return updated;
    });
  };

  /* =============================
        SUBMIT
  ============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await registerUserAPI(form);

      if (data.status === "success") {
        setShowSuccess(true);

        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      } else {
        alert(data.message || "Registration Failed!");
      }

    } catch (err) {
      alert(
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        "Registration Failed!"
      );
    }

    setLoading(false);
  };

  const roleLower = form.roleName.toLowerCase();
  const disableRM =
    roleLower === "manager" ||
    roleLower === "sbuhead" ||
    roleLower === "sbu head";

  return {
    form,
    roles,
    managers,
    sbuHeads,
    loading,
    showSuccess,
    roleLower,
    disableRM,
    handleInput,
    handleSubmit,
  };
}
